const client = {
  namespaced: true,
  state: {
    uuid: null,
    requests: 0,
    inOrder: true
  },
  mutations: {
    updateUUID(state, uuid) {
      state.uuid = uuid;
    },
    updateInOrder(state, inOrder) {
      state.inOrder = inOrder;
    },
    updateRequests(state, type) {
      state.requests = type === 'dec' ? state.requests - 1 : state.requests + 1;
    }
  },
  actions: {
    async checkInOrder({ dispatch, commit, state }) {
      commit('updateRequests');
      const request = await dispatch('calls/inOrder', state.uuid, { root: true });

      if (request.status === 'success') {
        commit('updateInOrder', request.data.inOrder);
      } else {
        commit('updateInOrder', false);
      }

      commit('updateRequests', 'dec');
    }
  }
};

export default client;
